var customIsoString = function(date, onlyDate) {
    var tzoffset = (new Date(date)).getTimezoneOffset() * 60000; //offset in milliseconds
    return onlyDate ? (new Date(date - tzoffset)).toISOString().split('T')[0] : (new Date(date - tzoffset)).toISOString();
};

export default customIsoString;